var React = require('react');

function InstagramLogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icons8-instagram","d":"M30.117,3A27.157,27.157,0,0,0,3,30.133v38.75A27.157,27.157,0,0,0,30.133,96h38.75A27.157,27.157,0,0,0,96,68.867V30.117A27.157,27.157,0,0,0,68.867,3ZM76.625,18.5a3.875,3.875,0,1,1-3.875,3.875A3.876,3.876,0,0,1,76.625,18.5ZM49.5,26.25A23.25,23.25,0,1,1,26.25,49.5,23.273,23.273,0,0,1,49.5,26.25Zm0,7.75A15.5,15.5,0,1,0,65,49.5,15.5,15.5,0,0,0,49.5,34Z","transform":"translate(-3 -3)","fill":"currentColor"}));
}

InstagramLogoInline.defaultProps = {"viewBox":"0 0 93 93"};

module.exports = InstagramLogoInline;

InstagramLogoInline.default = InstagramLogoInline;
